import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LogIn } from 'lucide-react';
import { startOidcLogin } from '../../services/oidc.service';
import { Button } from '@/components/ui-kit/button';
import { useToast } from '@/hooks/use-toast';

/**
 * The sign-in button. It opens IAM's hosted login through the Blocks OIDC client, where the user
 * picks the provider and IAM handles MFA.
 */
const SSOSigninCard = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const onClickHandler = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    setIsRedirecting(true);
    try {
      await startOidcLogin();
    } catch (error) {
      console.error('[SSO Button] Could not start the hosted login:', error);
      toast({ variant: 'destructive', title: t('ERROR'), description: t('PLEASE_TRY_AGAIN') });
      setIsRedirecting(false);
    }
  };

  return (
    <Button
      className="h-12 w-full rounded-lg bg-[#0066B2] text-base font-semibold text-[#FFFFFF] shadow-none hover:bg-[#005494] [&_svg:not([class*='size-'])]:size-5"
      onClick={onClickHandler}
      loading={isRedirecting}
      disabled={isRedirecting}
    >
      {!isRedirecting && <LogIn />}
      {isRedirecting ? t('LOGIN_REDIRECTING') : t('CONTINUE_WITH_PROVIDER', { provider: 'OIDC' })}
    </Button>
  );
};

export default SSOSigninCard;
